export const LOGIN = 'LOGIN';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const CASEDETAILS = 'GET_CASE_DETAILS';